import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_PROVIDER_DEMO_IEAM_1 = {
  title: "Onboarding application\n details form",
  subtitle: "Use case Provider demo",
  text: "To onboard the application, simply provide\n details such as the use case name, applicable\n industries, and a detailed description.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_106"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      console.log(previousPage());
      setCurrentPage(previousPage());
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_01_BG.png",
  rightSideImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_01_Laptop.png",
};
